import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import NavigationHelper from 'layers/navigation/navigationHelper'

import Breadcrumbs from './component'
import { getBreadcrumbLinks } from './helpers'

export const BreadcrumbsContainer = ({ breadcrumb, navigationEvent }) => {
  const links = getBreadcrumbLinks(breadcrumb)

  return <Breadcrumbs links={links} onNavigate={navigationEvent} />
}

BreadcrumbsContainer.propTypes = {
  breadcrumb: PropTypes.shape({
    route: PropTypes.arrayOf(
      PropTypes.shape({
        displayTitle: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
  }),
  navigationEvent: PropTypes.func,
}

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(BreadcrumbsContainer)
